import ResourceService from '../services/resources.service';
// import moment from 'moment';

export const resource = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getResources({ commit }){
      return ResourceService.getResources().then(
        resp => {
          commit('getList', resp);
          return Promise.resolve(resp);
        },
        error => {
          commit('getList');
          return Promise.reject(error);
        }
      )
    },

    uploadResource({ commit }, resource) {
      return ResourceService.uploadResource(resource).then(
        resp => {
          commit("uploadResource", resp);
          return Promise.resolve(resp);
        },
        error => {
          commit("uploadResource");
          return Promise.reject(error);
        }
      )
    },

    getResourceList({ commit }, resource) {
      return ResourceService.getResourceList(resource).then(
        resp => {
          commit("getResourceList", resp);
          return Promise.resolve(resp);
        },
        error => {
          commit("getResourceList");
          return Promise.reject(error);
        }
      )
    }    
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    }
  }
};